import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input', 'counter'];

  connect() {
    this.update();
  }

  update() {
    const length = this.inputTarget.value.length;
    const min = parseInt(this.data.get('min') || 15);
    const remaining = min - length;

    if (length === 0) {
      this.counterTarget.textContent = `Minimum ${min} characters`;
      this.counterTarget.className = 'mt-1 text-xs text-gray-500';
    } else if (remaining > 0) {
      this.counterTarget.textContent = `${remaining} more character${remaining === 1 ? '' : 's'} needed`;
      this.counterTarget.className = 'mt-1 text-xs text-red-500';
    } else {
      this.counterTarget.textContent = `${length} characters — meets minimum`;
      this.counterTarget.className = 'mt-1 text-xs text-green-600';
    }
  }
}
